import helpers from "./helpers/index.js";
export default class Helpers {
  install(Vue) {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  }
}
